import axios from 'axios';
import { toast } from 'react-toastify';
import { push } from 'connected-react-router';

// URIs
import serverURI from '../../config/URI';
// Helpers
import errorHandler from '../helpers/errorHandler';

//import { getParties } from './party';


export const LOADING_CAMPAIGNS = () => ({ type: 'LOADING_CAMPAIGNS', });
export const LOADING_CAMPAIGNS_SUCCESS = () => ({ type: 'LOADING_CAMPAIGNS_SUCCESS', });
export const LOADING_CAMPAIGNS_ERROR = () => ({ type: 'LOADING_CAMPAIGNS_ERROR', });

export const LOADING_CAMPAIGN_ADVERTISES = () => ({ type: 'LOADING_CAMPAIGN_ADVERTISES', });
export const LOADING_CAMPAIGN_ADVERTISES_SUCCESS = () => ({ type: 'LOADING_CAMPAIGN_ADVERTISES_SUCCESS', });
export const LOADING_CAMPAIGN_ADVERTISES_ERROR = () => ({ type: 'LOADING_CAMPAIGN_ADVERTISES_ERROR', });

export const ADDING_CAMPAIGN = () => ({ type: 'ADDING_CAMPAIGN', });
export const ADDING_CAMPAIGN_SUCCESS = () => ({ type: 'ADDING_CAMPAIGN_SUCCESS', });
export const ADDING_CAMPAIGN_ERROR = () => ({ type: 'ADDING_CAMPAIGN_ERROR', });

export const UPDATING_CAMPAIGN = () => ({ type: 'UPDATING_CAMPAIGN', });
export const UPDATING_CAMPAIGN_SUCCESS = () => ({ type: 'UPDATING_CAMPAIGN_SUCCESS', });
export const UPDATING_CAMPAIGN_ERROR = () => ({ type: 'UPDATING_CAMPAIGN_ERROR', });

export const DELETING_CAMPAIGN = () => ({ type: 'DELETING_CAMPAIGN', });
export const DELETING_CAMPAIGN_SUCCESS = () => ({ type: 'DELETING_CAMPAIGN_SUCCESS', });
export const DELETING_CAMPAIGN_ERROR = () => ({ type: 'DELETING_CAMPAIGN_ERROR', });

export const LOADING_CAMPAIGN_INFO = () => ({ type: 'LOADING_CAMPAIGN_INFO', });
export const LOADING_CAMPAIGN_INFO_SUCCESS = () => ({ type: 'LOADING_CAMPAIGN_INFO_SUCCESS', });
export const LOADING_CAMPAIGN_INFO_ERROR = () => ({ type: 'LOADING_CAMPAIGN_INFO_ERROR', });

export const FINDING_CAMPAIGNS = () => ({ type: 'FINDING_CAMPAIGNS', });
export const FINDING_CAMPAIGNS_SUCCESS = () => ({ type: 'FINDING_CAMPAIGNS_SUCCESS', });
export const FINDING_CAMPAIGNS_ERROR = () => ({ type: 'FINDING_CAMPAIGNS_ERROR', });

export const getCampaigns = (dispatch) => {
  dispatch({ type: LOADING_CAMPAIGNS });

  axios
    .get(`${serverURI}/api/campaign/all`)
    .then((res) => {
      dispatch({
        type: LOADING_CAMPAIGNS_SUCCESS,
        payload: res.data.campaigns
      });
    })
    .catch((err) => {
      dispatch({ type: LOADING_CAMPAIGNS_ERROR, payload: err });
      errorHandler(err);
    });
};


export const addCampaign = (campaign, dispatch) => {
  dispatch({ type: ADDING_CAMPAIGN });

  axios
    .post(`${serverURI}/api/campaign/add`, campaign)
    .then((res) => {
      dispatch({ type: ADDING_CAMPAIGN_SUCCESS, 
        payload: res.data.campaign, 
        });
    })
    .catch((err) => {
      dispatch({ type: ADDING_CAMPAIGN_ERROR, payload: err });
      errorHandler(err);
    });
};

export const updateCampaign = (id, campaign, dispatch) => {
  dispatch({ type: UPDATING_CAMPAIGN });

  axios
    .put(`${serverURI}/api/campaign/update/${id}`, campaign)
    .then((res) => {
      //console.log(res);
      dispatch({ type: UPDATING_CAMPAIGN_SUCCESS, 
        payload: res.data.campaign, 
        });
    })
    .catch((err) => {
      dispatch({ type: UPDATING_CAMPAIGN_ERROR, payload: err });
      errorHandler(err);
    });
};

export const deleteCampaign = (deletes, dispatch) => {
  dispatch({ type: DELETING_CAMPAIGN });

  const deleteData = {
    deletes: deletes,
  };

  return axios
    .delete(`${serverURI}/api/campaign/delete`, {data: deleteData})
    .then((res) => {
      //console.log(res);
      dispatch({ type: DELETING_CAMPAIGN_SUCCESS, 
        payload: res.data.deletedCampaigns, 
        });
    })
    .catch((err) => {
      dispatch({ type: DELETING_CAMPAIGN_ERROR, payload: err });
      errorHandler(err);
    });
};


export const getCampaignAdvertises = (template, dispatch) => {
  dispatch({ type: LOADING_CAMPAIGN_ADVERTISES });

  axios
    .get(`${serverURI}/api/campaign/advertise/all/${template}`)
    .then((res) => {
      dispatch({
        type: LOADING_CAMPAIGN_ADVERTISES_SUCCESS,
        payload: res.data.advertises
      });
    })
    .catch((err) => {
      dispatch({ type: LOADING_CAMPAIGN_ADVERTISES_ERROR, payload: err });
      errorHandler(err);
    });
};

export const getCampaignInfo = (id, dispatch) => {
  dispatch({ type: LOADING_CAMPAIGN_INFO });

  axios
    .get(`${serverURI}/api/campaign/info/${id}`)
    .then((res) => {
      dispatch({
        type: LOADING_CAMPAIGN_INFO_SUCCESS,
        payload: res.data.campaignInfo
      });
    })
    .catch((err) => {
      dispatch({ type: LOADING_CAMPAIGN_INFO_ERROR, payload: err });
      errorHandler(err);
    });
};


export const findCampaigns = (find, dispatch) => {
  dispatch({ type: FINDING_CAMPAIGNS });

  axios
    .post(`${serverURI}/api/campaign/find`, find)
    .then((res) => {
      //console.log(res);
      dispatch({ type: FINDING_CAMPAIGNS_SUCCESS, 
        payload: {
          find_total: res.data.total,
          find_campaigns: res.data.campaigns
        }
        });
    })
    .catch((err) => {
      dispatch({ type: FINDING_CAMPAIGNS_ERROR, payload: err });
      errorHandler(err);
    });
};

export const removeCampaigns = (dispatch) => {
  dispatch({ type: FINDING_CAMPAIGNS_SUCCESS, 
    payload: {
      find_total: 0,
      find_campaigns: []
    }
  });

};